// Single source of the Season "Loading snapshot…" caption (key + English fallback).
export const SNAPSHOT_LOADING_KEY = 'map.scorecards.loadingSnapshot';
export const SNAPSHOT_LOADING_FALLBACK = 'Loading snapshot…';
export const snapshotLoadingText = (t) => t(SNAPSHOT_LOADING_KEY, SNAPSHOT_LOADING_FALLBACK);
